<template lang="pug">
    div
        q_text(
        question="Work Experience"
        slug="q_work_experience"
        :multi_field_num="multi_field_num"
        )
        big(v-show="show_grades_title()") Grades Participated in
        q_checkbox(
        question="9"
        slug="q_work_9"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="10"
        slug="q_work_10"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="11"
        slug="q_work_11"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="12"
        slug="q_work_12"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="Post Graduation"
        slug="q_work_pg"
        :multi_field_num="multi_field_num"
        )
</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_checkbox from "../../baseQuestion/checkbox";
import q_text from "../../baseQuestion/text";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_checkbox,
		q_text
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		},
		show_grades_title() {
			let data = this.$store.state.q_work.answer;
			let i = this.multi_field_num - 1;
			if (!data || !data[i]) {
				return false;
			}

			return data[i].q_work_9.is_displayed;
		}
	}
};
</script>
